import React, {useEffect, useState} from "react";
import { Button, Typography } from "@mui/material";
import { StyledTextField, ConfirmationContainer, FormContainer } from "../styles";
import {useCustomer} from "context/customer/customerContext";
import { useUI } from "context/ui/uiContext";
import {useNavigate} from "react-router-dom";

/**
 *
 * @param root0
 * @param root0.setStep
 */
function Identity({ setStep }) {
  const {showAlert} = useUI();
  const navigate = useNavigate();
  const [last6VIN, setLast6VIN] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);

  const {confirmIdentity, customerDetails} = useCustomer();

  /** If we have a token and details, send them back through to they left off */
  useEffect(() => {
    if (customerDetails) {
      navigate("/customer/details");
    }
  }, [customerDetails]);

  const handleConfirmIdentity = async () => {
    try {
      if (!last6VIN || !accountNumber) {
        showAlert("VIN and account number are required", "error");
        return;
      }

      const response = await confirmIdentity({last6VIN, accountNumber});
      console.log("response", response);
      const {success, error} = response;

      if (!success) {
        showAlert(error, "error");
        return;
      }

      if (success) {
        navigate("/customer/details");
      }
    }
    catch (error) {
      console.log(error);
      showAlert(error.message, "error");
    }

  };

  return (
    <ConfirmationContainer>
      <FormContainer elevation={3}>
        <div
          // style={{ padding: '0 10px' }}
        >
          <Typography variant="h5" gutterBottom>
        Confirm Your Identity
          </Typography>
          <>
            <StyledTextField fullWidth label="Last 6 digits of VIN" variant="outlined" value={last6VIN} onChange={(e) => setLast6VIN(e.target.value)} />
            <StyledTextField fullWidth label="Account Number" variant="outlined" value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} />
          </>

          <Button variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }} fullWidth style={{ marginTop: "20px", padding: "12px 0" }} onClick={handleConfirmIdentity}>
        Confirm
          </Button>
          <Typography variant="body2" align="center" gutterBottom>
          Don’t know your VIN or your HDFS account number?
          </Typography>
          <Typography variant="body2" align="center" gutterBottom>
            Contact us at 800-717-3450 for assistance
          </Typography>
        </div>
      </FormContainer>
    </ConfirmationContainer>

  );
}

export default Identity;
